export class MyAppSettings {
   public static BACKEND_ENDPOINT: string = 'https://www.clear.gives/';
   /*public BACKEND_ENDPOINT: string = '';*/
}